import React from 'react';
import { HiOutlineUserGroup, HiOutlineExclamationTriangle, HiOutlineCube, HiOutlineGlobeAlt } from 'react-icons/hi2';

const Step1_FIR = ({ incidentData, setIncidentData, readOnly = false }) => {
  // If data isn't loaded yet
  if (!incidentData) return null;

  const handleChange = (field, value) => {
    if (readOnly || !setIncidentData) return;
    setIncidentData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleNestedChange = (category, field, value) => {
    if (readOnly || !setIncidentData) return;
    setIncidentData(prev => ({
      ...prev,
      [category]: {
        ...(prev[category] || {}),
        [field]: value
      }
    }));
  };

  const isInjury = incidentData.type === 'Injury';
  const isEquipment = incidentData.type === 'Equipment';
  const isEnvironment = incidentData.type === 'Environment';

  return (
    // <div className="bg-card p-6 rounded-xl border border-gray-200 shadow-sm max-w-4xl mx-auto my-0">
    //   <div className="border-b border-gray-200 pb-4 mb-6">
    //     <h2 className="text-xl font-bold text-primary">First Incident Report (FIR)</h2>
    //     <p className="text-tertiary text-base mt-1">Capture the initial facts and details immediately following the incident.</p>
    //   </div>

    //   <div className="space-y-8">
    //     {/* Section 1: Basic Details */}
    //     <section>
    //       <h3 className="text-lg font-semibold text-primary mb-4 flex items-center gap-2">
    //         <span className="bg-gray-100 p-1.5 rounded-md text-secondary">
    //           <HiOutlineExclamationTriangle className="w-5 h-5" />
    //         </span>
    //         Basic Information
    //       </h3>

    //       <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
    //         <div>
    //           <label className="block text-base font-medium text-secondary mb-1">Incident Title</label>
    //           <input
    //             type="text"
    //             className="w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-base bg-card"
    //             value={incidentData.title || ''}
    //             onChange={(e) => handleChange('title', e.target.value)}
    //             readOnly={readOnly}
    //             placeholder="Brief description of what happened..."
    //           />
    //         </div>

    //         <div>
    //           <label className="block text-base font-medium text-secondary mb-1">Incident Date & Time</label>
    //           <input
    //             type="datetime-local"
    //             className="w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-base bg-card"
    //             value={incidentData.incidentDate ? new Date(incidentData.incidentDate).toISOString().slice(0, 16) : ''}
    //             onChange={(e) => handleChange('incidentDate', new Date(e.target.value).toISOString())}
    //             readOnly={readOnly}
    //           />
    //         </div>

    //         <div>
    //           <label className="block text-base font-medium text-secondary mb-1">Plant / Site</label>
    //           <select
    //             className="w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-base bg-card"
    //             value={incidentData.plantName || ''}
    //             onChange={(e) => handleChange('plantName', e.target.value)}
    //             disabled={readOnly}
    //           >
    //             <option value="">Select Plant</option>
    //             <option value="Plant A">Plant A</option>
    //             <option value="Plant B">Plant B</option>
    //           </select>
    //         </div>

    //         <div>
    //           <label className="block text-base font-medium text-secondary mb-1">Department</label>
    //           <input
    //             type="text"
    //             className="w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-base bg-card"
    //             value={incidentData.department || ''}
    //             onChange={(e) => handleChange('department', e.target.value)}
    //             readOnly={readOnly}
    //           />
    //         </div>

    //         <div className="md:col-span-2">
    //           <label className="block text-base font-medium text-secondary mb-1">Incident Type</label>
    //           <select
    //             className="w-full md:w-1/2 rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-base bg-card"
    //             value={incidentData.type || ''}
    //             onChange={(e) => handleChange('type', e.target.value)}
    //             disabled={readOnly}
    //           >
    //             <option value="">Select Type</option>
    //             <option value="Injury">Health / Injury</option>
    //             <option value="Equipment">Equipment / Property Damage</option>
    //             <option value="Environment">Environmental Spill / Release</option>
    //             <option value="Road">Road Traffic Accident</option>
    //             <option value="Nearmiss">Near Miss / Good Catch</option>
    //           </select>
    //         </div>

    //         <div className="md:col-span-2">
    //           <label className="block text-base font-medium text-secondary mb-1">Detailed Description</label>
    //           <textarea
    //             rows={4}
    //             className="w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-base bg-card"
    //             value={incidentData.description || ''}
    //             onChange={(e) => handleChange('description', e.target.value)}
    //             readOnly={readOnly}
    //             placeholder="Describe exactly what happened, step by step..."
    //           />
    //         </div>
    //       </div>
    //     </section>

    //     {/* Section 2: Conditional Injury Details */}
    //     {isInjury && (
    //       <section className="bg-red-50/50 p-6 rounded-xl border border-red-100">
    //         <h3 className="text-lg font-semibold text-red-900 mb-4 flex items-center gap-2">
    //           <span className="bg-red-100 p-1.5 rounded-md text-red-600">
    //             <HiOutlineUserGroup className="w-5 h-5" />
    //           </span>
    //           Injury Details
    //         </h3>

    //         <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
    //           <div>
    //             <label className="block text-base font-medium text-secondary mb-1">Affected Person Type</label>
    //             <select
    //               className="w-full rounded-md border-gray-300 shadow-sm sm:text-base bg-card"
    //               value={incidentData.injuryDetails?.employeeType || ''}
    //               onChange={(e) => handleNestedChange('injuryDetails', 'employeeType', e.target.value)}
    //               disabled={readOnly}
    //             >
    //               <option value="Company Employee">Company Employee</option>
    //               <option value="Contractor">Contractor / Agency</option>
    //               <option value="Visitor">Visitor / 3rd Party</option>
    //             </select>
    //           </div>

    //           <div>
    //             <label className="block text-base font-medium text-secondary mb-1">Name of Injured Person</label>
    //             <input
    //               type="text"
    //               className="w-full rounded-md border-gray-300 shadow-sm sm:text-base bg-card"
    //               value={incidentData.injuryDetails?.employeeName || ''}
    //               onChange={(e) => handleNestedChange('injuryDetails', 'employeeName', e.target.value)}
    //               readOnly={readOnly}
    //             />
    //           </div>

    //           <div>
    //             <label className="block text-base font-medium text-secondary mb-1">Body Part Injured</label>
    //             <input
    //               type="text"
    //               className="w-full rounded-md border-gray-300 shadow-sm sm:text-base bg-card"
    //               value={incidentData.injuryDetails?.bodyPart || ''}
    //               onChange={(e) => handleNestedChange('injuryDetails', 'bodyPart', e.target.value)}
    //               readOnly={readOnly}
    //               placeholder="e.g. Left Index Finger, Right Ankle"
    //             />
    //           </div>

    //           <div>
    //             <label className="block text-base font-medium text-secondary mb-1">Injury Classification</label>
    //             <select
    //               className="w-full rounded-md border-gray-300 shadow-sm sm:text-base bg-card"
    //               value={incidentData.injuryDetails?.injuryType || ''}
    //               onChange={(e) => handleNestedChange('injuryDetails', 'injuryType', e.target.value)}
    //               disabled={readOnly}
    //             >
    //               <option value="">Select Classification</option>
    //               <option value="FAC">First Aid Case (FAC)</option>
    //               <option value="MTC">Medical Treatment Case (MTC)</option>
    //               <option value="RWC">Restricted Work Case (RWC)</option>
    //               <option value="LTC">Lost Time Case (LTC)</option>
    //               <option value="FATAL">Fatality (FATAL)</option>
    //             </select>
    //           </div>
    //         </div>
    //       </section>
    //     )}

    //     {/* Section 3: Conditional Equipment Details */}
    //     {isEquipment && (
    //       <section className="bg-orange-50/50 p-6 rounded-xl border border-orange-100">
    //         <h3 className="text-lg font-semibold text-orange-900 mb-4 flex items-center gap-2">
    //           <span className="bg-orange-100 p-1.5 rounded-md text-orange-600">
    //             <HiOutlineCube className="w-5 h-5" />
    //           </span>
    //           Equipment / Property Damage Details
    //         </h3>

    //         <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
    //           <div>
    //             <label className="block text-base font-medium text-secondary mb-1">Equipment Name / ID</label>
    //             <input
    //               type="text"
    //               className="w-full rounded-md border-gray-300 shadow-sm sm:text-base bg-card"
    //               value={incidentData.equipmentDetails?.equipmentName || ''}
    //               onChange={(e) => handleNestedChange('equipmentDetails', 'equipmentName', e.target.value)}
    //               readOnly={readOnly}
    //               placeholder="e.g. FL-102 Forklift"
    //             />
    //           </div>

    //           <div className="md:col-span-2">
    //             <label className="block text-base font-medium text-secondary mb-1">Damage Description</label>
    //             <textarea
    //               rows={3}
    //               className="w-full rounded-md border-gray-300 shadow-sm sm:text-base bg-card"
    //               value={incidentData.equipmentDetails?.damageDescription || ''}
    //               onChange={(e) => handleNestedChange('equipmentDetails', 'damageDescription', e.target.value)}
    //               readOnly={readOnly}
    //               placeholder="Describe the extent of damage to equipment or property..."
    //             />
    //           </div>
    //         </div>
    //       </section>
    //     )}

    //     {/* Section 4: Conditional Environment Details */}
    //     {isEnvironment && (
    //       <section className="bg-green-50/50 p-6 rounded-xl border border-green-100">
    //         <h3 className="text-lg font-semibold text-green-900 mb-4 flex items-center gap-2">
    //           <span className="bg-green-100 p-1.5 rounded-md text-green-600">
    //             <HiOutlineGlobeAlt className="w-5 h-5" />
    //           </span>
    //           Environmental Details
    //         </h3>

    //         <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
    //           <div>
    //             <label className="block text-base font-medium text-secondary mb-1">Substance Spilled / Released</label>
    //             <input
    //               type="text"
    //               className="w-full rounded-md border-gray-300 shadow-sm sm:text-base bg-card"
    //               value={incidentData.environmentalDetails?.substance || ''}
    //               onChange={(e) => handleNestedChange('environmentalDetails', 'substance', e.target.value)}
    //               readOnly={readOnly}
    //             />
    //           </div>

    //           <div>
    //             <label className="block text-base font-medium text-secondary mb-1">Quantity</label>
    //             <input
    //               type="text"
    //               className="w-full rounded-md border-gray-300 shadow-sm sm:text-base bg-card"
    //               value={incidentData.environmentalDetails?.quantitySpilled || ''}
    //               onChange={(e) => handleNestedChange('environmentalDetails', 'quantitySpilled', e.target.value)}
    //               readOnly={readOnly}
    //               placeholder="e.g. 5 liters, 100 kg"
    //             />
    //           </div>

    //           <div className="md:col-span-2 flex items-center mt-2">
    //             <input
    //               type="checkbox"
    //               className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
    //               checked={incidentData.environmentalDetails?.containmentSuccessful || false}
    //               readOnly={readOnly}
    //               disabled={readOnly}
    //             />
    //             <label className="ml-2 block text-base text-primary">
    //               Release was successfully contained onsite (did not enter drains/public waterways).
    //             </label>
    //           </div>
    //         </div>
    //       </section>
    //     )}
    //   </div>
    // </div>

    <div className="bg-card rounded-2xl border border-gray-200 shadow-sm max-w-4xl mx-auto my-0 overflow-hidden">
      {/* Card Header */}
      <div className="px-6 py-5 border-b border-gray-200 flex items-center gap-3">
        <div className="w-9 h-9 rounded-lg bg-amber-50 flex items-center justify-center text-amber-600 flex-shrink-0">
          <HiOutlineExclamationTriangle className="w-5 h-5" />
        </div>
        <div>
          <h2 className="text-md font-bold text-primary">First Incident Report (FIR)</h2>
          <p className="text-sm text-gray-400 font-normal mt-0.5">Capture the initial facts and details immediately following the incident.</p>
        </div>
      </div>

      <div className="p-6 space-y-8">

        {/* ── Section 1: Basic Information ── */}
        <section>
          <div className="flex items-center gap-3 mb-5">
            <div className="flex-1 h-px bg-gray-100" />
            <span className="text-[15px] font-semibold tracking-widest uppercase text-gray-400">Basic Information</span>
            <div className="flex-1 h-px bg-gray-100" />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-5">
            <div className="flex flex-col gap-1.5">
              <label className="text-[13px] font-semibold text-tertiary tracking-wide">
                Incident Title <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                className="w-full rounded-lg border border-gray-200 bg-card px-3 py-2 text-sm text-primary placeholder:text-gray-300   outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100 shadow-none"
                value={incidentData.title || ''}
                onChange={(e) => handleChange('title', e.target.value)}
                readOnly={readOnly}
                placeholder="Brief description of what happened..."
              />
            </div>

            <div className="flex flex-col gap-1.5">
              <label className="text-[13px] font-semibold text-tertiary tracking-wide">
                Incident Date &amp; Time <span className="text-red-500">*</span>
              </label>
              <input
                type="datetime-local"
                className="w-full rounded-lg border border-gray-200 bg-card px-3 py-2 text-sm text-primary    outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
                value={incidentData.incidentDate ? new Date(incidentData.incidentDate).toISOString().slice(0, 16) : ''}
                onChange={(e) => handleChange('incidentDate', new Date(e.target.value).toISOString())}
                readOnly={readOnly}
              />
            </div>

            <div className="flex flex-col gap-1.5">
              <label className="text-[13px] font-semibold text-tertiary tracking-wide">
                Plant / Site <span className="text-red-500">*</span>
              </label>
              <select
                className="w-full rounded-lg border border-gray-200 bg-card px-3 py-2 text-sm text-primary   outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100 cursor-pointer appearance-none"
                value={incidentData.plantName || ''}
                onChange={(e) => handleChange('plantName', e.target.value)}
                disabled={readOnly}
              >
                <option value="">Select Plant</option>
                <option value="Plant A">Plant A</option>
                <option value="Plant B">Plant B</option>
              </select>
            </div>

            <div className="flex flex-col gap-1.5">
              <label className="text-[13px] font-semibold text-tertiary tracking-wide">Department</label>
              <input
                type="text"
                className="w-full rounded-lg border border-gray-200 bg-card px-3 py-2 text-sm text-primary placeholder:text-gray-300   outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
                value={incidentData.department || ''}
                onChange={(e) => handleChange('department', e.target.value)}
                readOnly={readOnly}
              />
            </div>

            <div className="md:col-span-2 flex flex-col gap-1.5">
              <label className="text-[13px] font-semibold text-tertiary tracking-wide">
                Incident Type <span className="text-red-500">*</span>
              </label>
              <select
                className="w-full md:w-1/2 rounded-lg border border-gray-200 bg-card px-3 py-2 text-sm text-primary   outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100 cursor-pointer appearance-none"
                value={incidentData.type || ''}
                onChange={(e) => handleChange('type', e.target.value)}
                disabled={readOnly}
              >
                <option value="">Select Type</option>
                <option value="Injury">Health / Injury</option>
                <option value="Equipment">Equipment / Property Damage</option>
                <option value="Environment">Environmental Spill / Release</option>
                <option value="Road">Road Traffic Accident</option>
                <option value="Nearmiss">Near Miss / Good Catch</option>
              </select>
            </div>

            <div className="md:col-span-2 flex flex-col gap-1.5">
              <label className="text-[13px] font-semibold text-tertiary tracking-wide">
                Detailed Description <span className="text-red-500">*</span>
              </label>
              <textarea
                rows={4}
                className="w-full rounded-lg border border-gray-200 bg-card px-3 py-2 text-sm text-primary placeholder:text-gray-300   outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100 resize-none leading-relaxed"
                value={incidentData.description || ''}
                onChange={(e) => handleChange('description', e.target.value)}
                readOnly={readOnly}
                placeholder="Describe exactly what happened, step by step..."
              />
            </div>
          </div>
        </section>

        {/* ── Section 2: Injury Details (conditional) ── */}
        {isInjury && (
          <section className="bg-red-50/60 rounded-xl border border-red-100 overflow-hidden">
            <div className="px-5 py-4 border-b border-red-100 flex items-center gap-3">
              <div className="w-8 h-8 rounded-lg bg-red-100 flex items-center justify-center text-red-600 flex-shrink-0">
                <HiOutlineUserGroup className="w-4 h-4" />
              </div>
              <div>
                <h3 className="text-sm font-bold text-red-800 mb-0">Injury Details</h3>
                <p className="text-[12px] text-red-400 font-normal">Complete if the incident involved a person getting hurt.</p>
              </div>
            </div>

            <div className="p-5">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-5">
                <div className="flex flex-col gap-1.5">
                  <label className="text-[13px] font-semibold text-tertiary tracking-wide">Affected Person Type</label>
                  <select
                    className="w-full rounded-lg border border-red-200 bg-card px-3 py-2 text-xs text-primary   outline-none transition focus:border-red-400 focus:ring-2 focus:ring-red-100 cursor-pointer appearance-none"
                    value={incidentData.injuryDetails?.employeeType || ''}
                    onChange={(e) => handleNestedChange('injuryDetails', 'employeeType', e.target.value)}
                    disabled={readOnly}
                  >
                    <option value="Company Employee">Company Employee</option>
                    <option value="Contractor">Contractor / Agency</option>
                    <option value="Visitor">Visitor / 3rd Party</option>
                  </select>
                </div>

                <div className="flex flex-col gap-1.5">
                  <label className="text-[13px] font-semibold text-tertiary tracking-wide">Name of Injured Person</label>
                  <input
                    type="text"
                    className="w-full rounded-lg border border-red-200 bg-card px-3 py-2 text-xs text-primary placeholder:text-gray-300   outline-none transition focus:border-red-400 focus:ring-2 focus:ring-red-100"
                    value={incidentData.injuryDetails?.employeeName || ''}
                    onChange={(e) => handleNestedChange('injuryDetails', 'employeeName', e.target.value)}
                    readOnly={readOnly}
                  />
                </div>

                <div className="flex flex-col gap-1.5">
                  <label className="text-[13px] font-semibold text-tertiary tracking-wide">Body Part Injured</label>
                  <input
                    type="text"
                    className="w-full rounded-lg border border-red-200 bg-card px-3 py-2 text-xs text-primary placeholder:text-gray-300   outline-none transition focus:border-red-400 focus:ring-2 focus:ring-red-100"
                    value={incidentData.injuryDetails?.bodyPart || ''}
                    onChange={(e) => handleNestedChange('injuryDetails', 'bodyPart', e.target.value)}
                    readOnly={readOnly}
                    placeholder="e.g. Left Index Finger, Right Ankle"
                  />
                </div>

                <div className="flex flex-col gap-1.5">
                  <label className="text-[13px] font-semibold text-tertiary tracking-wide">Injury Classification</label>
                  <select
                    className="w-full rounded-lg border border-red-200 bg-card px-3 py-2 text-xs text-primary   outline-none transition focus:border-red-400 focus:ring-2 focus:ring-red-100 cursor-pointer appearance-none"
                    value={incidentData.injuryDetails?.injuryType || ''}
                    onChange={(e) => handleNestedChange('injuryDetails', 'injuryType', e.target.value)}
                    disabled={readOnly}
                  >
                    <option value="">Select Classification</option>
                    <option value="FAC">First Aid Case (FAC)</option>
                    <option value="MTC">Medical Treatment Case (MTC)</option>
                    <option value="RWC">Restricted Work Case (RWC)</option>
                    <option value="LTC">Lost Time Case (LTC)</option>
                    <option value="FATAL">Fatality (FATAL)</option>
                  </select>
                </div>
              </div>
            </div>
          </section>
        )}

        {/* ── Section 3: Equipment Details (conditional) ── */}
        {isEquipment && (
          <section className="bg-orange-50/60 rounded-xl border border-orange-100 overflow-hidden">
            <div className="px-5 py-4 border-b border-orange-100 flex items-center gap-3">
              <div className="w-8 h-8 rounded-lg bg-orange-100 flex items-center justify-center text-orange-600 flex-shrink-0">
                <HiOutlineCube className="w-4 h-4" />
              </div>
              <div>
                <h3 className="text-sm font-bold text-orange-800 mb-0">Equipment / Property Damage Details</h3>
                <p className="text-[12px] text-orange-400 font-normal">Record what equipment or property was affected.</p>
              </div>
            </div>

            <div className="p-5">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-5">
                <div className="flex flex-col gap-1.5">
                  <label className="text-[13px] font-semibold text-tertiary tracking-wide">Equipment Name / ID</label>
                  <input
                    type="text"
                    className="w-full rounded-lg border border-orange-200 bg-card px-3 py-2 text-xs text-primary placeholder:text-gray-300   outline-none transition focus:border-orange-400 focus:ring-2 focus:ring-orange-100"
                    value={incidentData.equipmentDetails?.equipmentName || ''}
                    onChange={(e) => handleNestedChange('equipmentDetails', 'equipmentName', e.target.value)}
                    readOnly={readOnly}
                    placeholder="e.g. FL-102 Forklift"
                  />
                </div>

                <div className="md:col-span-2 flex flex-col gap-1.5">
                  <label className="text-[13px] font-semibold text-tertiary tracking-wide">Damage Description</label>
                  <textarea
                    rows={3}
                    className="w-full rounded-lg border border-orange-200 bg-card px-3 py-2 text-xs text-primary placeholder:text-gray-300   outline-none transition focus:border-orange-400 focus:ring-2 focus:ring-orange-100 resize-none leading-relaxed"
                    value={incidentData.equipmentDetails?.damageDescription || ''}
                    onChange={(e) => handleNestedChange('equipmentDetails', 'damageDescription', e.target.value)}
                    readOnly={readOnly}
                    placeholder="Describe the extent of damage to equipment or property..."
                  />
                </div>
              </div>
            </div>
          </section>
        )}

        {/* ── Section 4: Environment Details (conditional) ── */}
        {isEnvironment && (
          <section className="bg-emerald-50/60 rounded-xl border border-emerald-100 overflow-hidden">
            <div className="px-5 py-4 border-b border-emerald-100 flex items-center gap-3">
              <div className="w-8 h-8 rounded-lg bg-emerald-100 flex items-center justify-center text-emerald-600 flex-shrink-0">
                <HiOutlineGlobeAlt className="w-4 h-4" />
              </div>
              <div>
                <h3 className="text-sm font-bold text-emerald-800 mb-0">Environmental Details</h3>
                <p className="text-[12px] text-emerald-500 font-normal">Record details about the environmental spill or release.</p>
              </div>
            </div>

            <div className="p-5">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-5">
                <div className="flex flex-col gap-1.5">
                  <label className="text-[13px] font-semibold text-tertiary tracking-wide">Substance Spilled / Released</label>
                  <input
                    type="text"
                    className="w-full rounded-lg border border-emerald-200 bg-card px-3 py-2 text-xs text-primary placeholder:text-gray-300   outline-none transition focus:border-emerald-400 focus:ring-2 focus:ring-emerald-100"
                    value={incidentData.environmentalDetails?.substance || ''}
                    onChange={(e) => handleNestedChange('environmentalDetails', 'substance', e.target.value)}
                    readOnly={readOnly}
                  />
                </div>

                <div className="flex flex-col gap-1.5">
                  <label className="text-[13px] font-semibold text-tertiary tracking-wide">Quantity</label>
                  <input
                    type="text"
                    className="w-full rounded-lg border border-emerald-200 bg-card px-3 py-2 text-xs text-primary placeholder:text-gray-300   outline-none transition focus:border-emerald-400 focus:ring-2 focus:ring-emerald-100"
                    value={incidentData.environmentalDetails?.quantitySpilled || ''}
                    onChange={(e) => handleNestedChange('environmentalDetails', 'quantitySpilled', e.target.value)}
                    readOnly={readOnly}
                    placeholder="e.g. 5 liters, 100 kg"
                  />
                </div>

                <div className="md:col-span-2 flex items-center gap-2.5 mt-1">
                  <input
                    type="checkbox"
                    className="h-4 w-4 rounded border-gray-300 text-emerald-600 focus:ring-emerald-500 cursor-pointer"
                    checked={incidentData.environmentalDetails?.containmentSuccessful || false}
                    readOnly={readOnly}
                    disabled={readOnly}
                  />
                  <label className="text-xs text-secondary font-medium">
                    Release was successfully contained onsite (did not enter drains / public waterways).
                  </label>
                </div>
              </div>
            </div>
          </section>
        )}

      </div>
    </div>
  );
};

export default Step1_FIR;
